import { render } from "./PwPosOverview.vue?vue&type=template&id=1b8f6f34"
import script from "./PwPosOverview.vue?vue&type=script&lang=js"
export * from "./PwPosOverview.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__